import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '@environments/environment-urls';
import { Observable } from 'rxjs';

import { ClinicianDashboard } from '../models/clinicianDashboard.model';

@Injectable({
  providedIn: 'root',
})
export class ClinicianDashboardApiService {
  private readonly http = inject(HttpClient);

  public getClinicianDashboard(): Observable<ClinicianDashboard> {
    return this.http.get<ClinicianDashboard>(`${environment.apiUrl}/user/api/v1/clinician/dashboard`);
  }

  public getClinicianAvatar(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/user/api/v1/clinician/dashboard/avatar`, { responseType: 'blob' });
  }
}
